import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ResidenceTodoApiService } from '@_services/api/residence-todo-api.service';
import { AppState } from '@_store/index.reducers';
import { GeneratedResidenceTodoEffects } from './residence-todo-generated.effects';

@Injectable()
export class ResidenceTodoEffects extends GeneratedResidenceTodoEffects {
  constructor(actions$: Actions, residenceTodoApiService: ResidenceTodoApiService, store$: Store<AppState>) {
    super(actions$, residenceTodoApiService, store$);
  }
}
